export function item(state, data) {
  state.item = data
}

export function items(state, data) {
  state.items = data
}

export function pagination(state, data) {
  state.pagination = data
}

export function token(state, data) {
  state.token = data
}

export function wsItem(state, data) {
  state.wsItem = data
}

export function me(state, data) {
  state.me = data
}
